import React, { useState } from 'react';
import styles from './DynamicTextList.module.css';



/* ---------- Single auto-complete input ---------- */
function AutoCompleteInput({ value, onChange, candidates = [] }) {
    const [show, setShow] = useState(false);
    const [activeIdx, setActiveIdx] = useState(0);

    /* Filter list by “contains” (case-insensitive) */
    const filtered = candidates.filter(c =>
        c.toLowerCase().includes(value.toLowerCase())
    );

    /* ------------ Handlers ------------ */
    const handleChange = e => {
        onChange(e.target.value);
        setShow(true);
        setActiveIdx(0);
    };

    const handleSelect = suggestion => {
        onChange(suggestion);
        setShow(false);
    };

    /*  Basic ↑ / ↓ / Enter keyboard control */
    const handleKeyDown = e => {
        if (!show) return;

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setActiveIdx(i => (i + 1) % filtered.length);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setActiveIdx(i =>
                i === 0 ? filtered.length - 1 : i - 1
            );
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (filtered.length) handleSelect(filtered[activeIdx]);
        } else if (e.key === 'Escape') {
            setShow(false);
        }
    };

    return (
        <div className={styles.autoCompleteWrapper}>
            <input
                className={`input-text ${styles["input"]}`}
                type="text"
                placeholder="Type or select…"
                value={value}
                onChange={handleChange}
                onFocus={() => value && setShow(true)}
                onBlur={() => {
                    /* Small timeout lets onMouseDown of a suggestion fire first */
                    setTimeout(() => setShow(false), 80);
                }}
                onKeyDown={handleKeyDown}
            />

            {show && filtered.length > 0 && (
                <ul className={styles.suggestionList}>
                    {filtered.map((item, idx) => (
                        <li
                            key={item}
                            className={`${styles.suggestionItem}${
                                idx === activeIdx ? ` ${styles.active}` : ''
                            }`}
                            onMouseDown={() => handleSelect(item)}  /* ← keep focus */
                        >
                            {item}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default AutoCompleteInput;